
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.071 4.071v2.907l2.493-1.06a1.072 1.072 0 01.9 1.936 1.065 1.065 0 01-.251.1l-2.471 1.03 1.583 2.261a1.071 1.071 0 11-1.691 1.314L8 10.232l-1.631 2.329a1.073 1.073 0 11-1.694-1.316l1.583-2.261-2.467-1.021a1.065 1.065 0 01-.251-.1 1.072 1.072 0 01.917-1.929l2.472 1.044V4.071a1.071 1.071 0 012.143 0z","fill":"#990ae3"}})])
          )
        }
      }
    